import React from 'react'
import { pure } from 'recompose'

import { schemeCategory20c } from 'analytics'
import { scaleOrdinal } from 'd3-scale'

import { arc, pie } from 'd3-shape'
import R from 'ramda'

import { fromNullable } from 'data.maybe'

import styled from 'styled-components'

const defaultColorScheme = schemeCategory20c

const createToolTip = (toolTipRenderer, data) =>
  fromNullable(toolTipRenderer)
    .map(render => <title key={data}>{render(data)}</title>)
    .getOrElse(null)

const Donut = ({
  width,
  height,
  data,
  pieVal,
  sliceKey,
  colorScheme,
  colorVal,
  tooltip,
  label,
  select,
  identifySelection,
  fontSizeMultipler = 1,
  className,
  hoverColor = '#444',
  selected,
  matchData = (a, b) => a === b,
}) => {
  const _createSlice = fill => styled.path`
    cursor: pointer;
    fill: ${fill};
    &:hover {
      fill: ${hoverColor};
      stroke: #444;
      stroke-width: 2px;
    }
  `
  const createSlice = _createSlice

  const cScale = scaleOrdinal(fromNullable(colorScheme).getOrElse(defaultColorScheme))

  const radius = Math.min(width, height) / 2

  const pieRenderer = pie().value(pieVal)

  const arcRenderer = arc()
    .outerRadius(radius * 0.85)
    .innerRadius(radius * 0.55)

  const selectedRenderer = arc()
    .outerRadius(radius * 0.95)
    .innerRadius(radius * 0.55)
    .padAngle(0.01)

  const fontSize = (radius / 7) * fontSizeMultipler

  const Label = styled.text`
    font-size: ${fontSize}px
    font-weight: bold;
    text-anchor: middle;
    fill: #4c4c4c;
  `
  return (
    <svg className={className} width={width} height={height}>
      <g transform={`translate(${width / 2},${height / 2})`}>
        {pieRenderer(data).map(({ data: d, ...slice }) => {
          const Slice = createSlice(cScale(colorVal(d)))

          const renderer = selected && matchData(d, selected) ? selectedRenderer : arcRenderer

          return (
            <g key={sliceKey(d)}>
              <Slice d={renderer(slice)} onClick={() => select && select(identifySelection(d))}>
                {createToolTip(tooltip, d)}
              </Slice>
            </g>
          )
        })}
      </g>
      <g
        transform={`translate(${width / 2},${height / 2 - (label.length * (fontSize * 0.65)) / 2})`}
      >
        <Label>
          {label.map((l, index) => (
            <tspan key={index} x="0" dy={index === 0 ? undefined : '1.2em'}>
              {l}
            </tspan>
          ))}
        </Label>
      </g>
    </svg>
  )
}
const NoDataWrapper = props =>
  fromNullable(R.isEmpty(props.data) ? null : props.data)
    .map(ag => <Donut key={ag} {...props} />)
    .getOrElse(null)

export default pure(NoDataWrapper)
